module.exports = __webpack_public_path__ + "static/media/p208korsi.82dce3d4.jpg";